import { decodeBase64 as base64  } from './lib.base64'

export const filterSearchParams = (data?: string | null): Array<[string, any]> | null => {
	const entries: [string, any][] | undefined = data?.split(',')
		.map((s: string) => s.split(':', 2).map(decodeURIComponent) as [string, string])
		.map(([k, v]) => [k, JSON.parse(base64(v))])
	return entries ?? null
}